import { useEffect, useState } from 'react';
import { useField } from 'informed';
import { TextField, FormControl, FormLabel } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

// types and classes
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

interface InformedTextFieldProps {
  name: string;
  label?: string;
  helperText?: $TSFixMe;
  defaultValue?: $TSFixMe;
  classes?: $TSFixMe;
  className?: $TSFixMe;
  validate?: $TSFixMe;
  required?: $TSFixMe;
  validateOnChange?: $TSFixMe;
  variant?: $TSFixMe;
  onBlur?: $TSFixMe;
  options: Array<string>;
  [k: string]: $TSFixMe;
}
export const InformedMaterialAutocomplete = (props: InformedTextFieldProps) => {
  const {
    helperText,
    defaultValue,
    // eslint-disable-next-line no-unused-vars
    name,
    label,
    className,
    validate,
    required,
    // eslint-disable-next-line no-unused-vars
    variant = 'standard',
    onBlur: passedInOnblur,
    options = [],
    freeSolo = true,
    autoHighlight = false,
    getOptionLabel,
    filterOptions,
    includeInputInList,
    onChange,
    onInputChange,
    ...otherProps
  } = props;

  const labelLength = label ? label.length : 0;

  const { fieldState, fieldApi, render, ref, userProps, ...rest } = useField({
    ...props,
  });

  const { value } = fieldState;
  const { setValue, setTouched, setError } = fieldApi;

  const [inputValue, setInputValue] = useState<string>('');

  //set the value
  useEffect(() => {
    if (props.value !== undefined) {
      setValue(String(props.value));
    } else if (
      (value === undefined || value === '') &&
      defaultValue !== undefined
    ) {
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, props.value]);

  //set the error, if provided as a prop
  useEffect(() => {
    if (props.error === true) {
      setError(props.helperText ? props.helperText : 'Error');
    } else if (props.error === false) {
      setError(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.error]);

  useEffect(() => {
    if (typeof value === 'string') {
      setInputValue(value);
    }
  }, [value]);

  // if the field is in an error state, display text: fieldState.error (or helpText as a fallback). Otherwise, don't display anything
  let actualHelperText: string | undefined;
  if (props.error || fieldState.error) {
    actualHelperText = String(
      fieldState.error ? fieldState.error : props.helperText,
    );
  } else {
    actualHelperText = undefined;
  }

  return render(
    <>
      <FormControl
        variant={variant}
        className={className}
        error={!!fieldState.error}
        {...otherProps}
      >
        {labelLength >= 80 ? (
          <FormLabel htmlFor={name}>{label}</FormLabel>
        ) : null}
        <Autocomplete
          {...rest}
          id={name}
          value={value}
          inputValue={inputValue}
          ref={ref}
          disabled={props.disabled}
          //default to the prop; otherwise the formstate
          options={options}
          getOptionLabel={getOptionLabel}
          filterOptions={filterOptions}
          includeInputInList={includeInputInList}
          onChange={(e, newValue, ...rest) => {
            setValue(newValue);
            if (onChange) {
              onChange(e, newValue, ...rest);
            }
          }}
          onBlur={(e) => {
            setTouched(true);
            if (props.onBlur) {
              props.onBlur(e);
            }
          }}
          onInputChange={(_e, newInputValue, ...rest) => {
            setInputValue(newInputValue);
            setValue(newInputValue);
            if (onInputChange) {
              onInputChange(_e, newInputValue, ...rest);
            }
          }}
          freeSolo={freeSolo}
          autoHighlight={autoHighlight}
          renderInput={(params) => (
            <TextField
              variant={variant}
              label={labelLength <= 79 ? label : null}
              name={name}
              error={
                props.error === undefined ? !!fieldState.error : props.error
              }
              helperText={actualHelperText}
              {...params}
            />
          )}
        />
      </FormControl>
    </>,
  );
};
